import { Module } from 'vuex'
import api from '../../api/v2/api'
import Menu from '../../api/v2/models/menu'

class MenuState {
  menus: Menu[] = []

  async getMenus (){
    this.menus = await api.menu.index()
  }

  get filteredMenus(){
    const result = []

    this.menus.forEach((menu)=>{
      // 表示出来るものだけ絞り込む
      if (this.isShowMenu(menu)) {
        const clone = new Menu(menu)

        // Menuの場合、Menus Itemを絞り込む
        if (menu.kbn == 'MENU_KBN_MENU') {
          clone.menuItems = menu.menuItems.filter(this.isShowMenu)

          if (clone.menuItems.length) {
            result.push(clone)
          }
        } else {
          result.push(clone)
        }
      }
    })

    return result
  }

  private isShowMenu(menu: Menu) {
    return !([
      "MENU_KBN_LOGIN",
      "MENU_KBN_LOGOUT",
      "MENU_KBN_MY_CLASSROOM"
    ].includes(menu.kbn))
  }
}

export const menuState = new MenuState()
